// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H14.3895C13.8269 21.1372 13.5 20.1068 13.5 19C13.5 15.9624 15.9624 13.5 19 13.5C20.1068 13.5 21.1372 13.8269 22 14.3895V2ZM15 7V9H13V14.5C13 15.8807 11.8807 17 10.5 17C9.11929 17 8 15.8807 8 14.5C8 13.1193 9.11929 12 10.5 12C10.6712 12 10.8384 12.0172 11 12.05V7H15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 20H23V18H20V15H18V18H15V20H18V23H20V20Z"}}]};

const MusicRectangleAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'music-rectangle-add-filled',
    ref,
    icon: element,
  },
));

MusicRectangleAddFilledIcon.displayName = 'MusicRectangleAddFilledIcon';

export default MusicRectangleAddFilledIcon;
